
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual-integration",
      function () {
        return require("private-next-pages/manual-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual-integration"])
      });
    }
  